<template>
  <VCareCalendarWidget v-bind="widgetData" :isLoading="isLoading" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import careCalendarWidgetQuery from "~/api/careCalendarWidgetQuery";
import { CareCalendarWidgetState } from "~/bff-types/types";
import VCareCalendarWidget from "~/components/VCareCalendarWidget";
import { logger } from "~/services/logger";

export default defineComponent({
  data() {
    return {
      widgetData: undefined as CareCalendarWidgetState | undefined,
      isLoading: false,
    };
  },
  components: {
    VCareCalendarWidget,
  },
  async created() {
    await this.fetchCareCalendarWidget();
  },
  mounted() {
    window.addEventListener(
      "hey-obi-web:content:care-calendar:reload-topics",
      () => this.fetchCareCalendarWidget()
    );
  },
  unmounted() {
    window.removeEventListener(
      "hey-obi-web:content:care-calendar:reload-topics",
      () => this.fetchCareCalendarWidget()
    );
  },
  methods: {
    async fetchCareCalendarWidget() {
      try {
        logger.logInfo("[Care Calendar Widget] Fetching...");
        this.isLoading = true;
        const result = await careCalendarWidgetQuery();
        this.widgetData = result?.state ?? undefined;
        this.isLoading = false;
      } catch (e) {
        logger.logError("[Care Calendar Widget] Query failed", e);
      }
    },
  },
});
</script>
